import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EventQueryParams } from '../../store/calendar/model/event-query-params.model';
import { Event } from '../../store/calendar/model/event.model';
import { User } from '../../store/authentication/model/user.model';

@Injectable({
    providedIn: 'root'
})
export class EventService {
    constructor(private http: HttpClient) {}

    loadEventsBetweenDates(queryParams: EventQueryParams): Observable<Event[]> {
        return this.http.get<Event[]>(
            `${environment.host}/calendar/events?startDate=${queryParams.startDate}&endDate=${queryParams.endDate}&categoryFilter=${queryParams.categoryFilter || ''}&roomFilter=${
                queryParams.roomFilter || ''
            }&levelFilter=${queryParams.levelFilter || ''}&courseNameSearchVal=${queryParams.courseNameSearchVal || ''}`
        );
    }

    saveEvent(event: Event, updateSeries: boolean, isUpdate: boolean, sendEventUpdate: boolean): Observable<Event[]> {
        // event.updateSeries = updateSeries;
        if (isUpdate) {
            return this.http.put<Event>(`${environment.host}/calendar/events/${event.id}?sendEventUpdate=${sendEventUpdate}`, JSON.stringify(event)).pipe(map((event) => [event]));
        } else {
            return this.http.post<Event[]>(`${environment.host}/calendar/events`, JSON.stringify(event));
        }
    }

    loadEventById(id: number): Observable<Event> {
        return this.http.get<Event>(`${environment.host}/calendar/events/${id}`);
    }

    deleteEvent(id: number, deleteSeries: boolean): Observable<Event> {
        return this.http.delete<Event>(`${environment.host}/calendar/events/${id}?deleteSeries=${deleteSeries}`);
    }

    cancelEvent(event: Event): Observable<Event> {
        return this.http.put<Event>(`${environment.host}/calendar/events/notTakePlace/${event.id}`, JSON.stringify(event));
    }

    eventTakePlace(event: Event): Observable<Event> {
        return this.http.put<Event>(`${environment.host}/calendar/events/takePlace/${event.id}`, JSON.stringify(event));
    }

    moveEvent(event: Event): Observable<Event> {
        return this.http.put<Event>(`${environment.host}/calendar/events/move/${event.id}`, JSON.stringify(event));
    }

    hasSimultaneousParticipation(id: number): Observable<{ hasSimultaneousParticipations: boolean }> {
        return this.http.get<{
            hasSimultaneousParticipations: boolean;
        }>(`${environment.host}/calendar/events/${id}/simultaneousParticipation`);
    }

    getEventSeries(id: number): Observable<Event[]> {
        return this.http.get<Event[]>(`${environment.host}/calendar/courses/${id}/events`);
    }

    subscribeToEvent(userId: number, eventId: number): Observable<Event> {
        return this.http.post<Event>(`${environment.host}/calendar/events/${eventId}/participation/${userId}?assignmentId=-1`, JSON.stringify(null));
    }

    unsubscribeFromEvent(userId: number, eventId: number): Observable<Event> {
        return this.http.delete<Event>(`${environment.host}/calendar/events/${eventId}/participation/${userId}`);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    unsubscriptionCause(userId: number, eventId: number, cause: { cause: string }): Observable<any> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.http.put<any>(`${environment.host}/calendar/events/${eventId}/unsubscriptionCause/${userId}`, JSON.stringify(cause));
    }

    isUserParticipantOfEvent(user: User, event: Event): boolean {
        return event.participants.some((participant) => participant.userAccount.id === user.id);
    }

    subscribeToWorkshop(userId: number, courseId: number): Observable<Event[]> {
        return this.http.post<Event[]>(`${environment.host}/calendar/courses/${courseId}/participation/${userId}?assignmentId=-1`, JSON.stringify(null));
    }

    unsubscribeFromAllWorkshopEvents(userId: number, courseId: number): Observable<Event[]> {
        return this.http.delete<Event[]>(`${environment.host}/calendar/courses/${courseId}/participation/${userId}`);
    }
}
